import { EnhancedDeckline } from 'types/DecklinesContext.types';

export const removeFootnoteIdsFromText = (text: string, footnote_ids: (number | null)[]) => {
  let footnotesString = '';
  let extractedText = '';
  if (footnote_ids && footnote_ids.length > 0) {
    footnotesString = footnote_ids.join(',');
  }

  if (footnotesString.length > 0) {
    // Use last index to search for footnotesString as the last portion of the text is the footnotes section
    // Eg: Deckline11 -> If footnotes array is [1], then extracted text is Deckline1 and the next 1 is the footnote superscript.
    extractedText = text.substring(0, text.lastIndexOf(footnotesString));
  }
  return extractedText;
};

/**
 * A map of numbers to their Unicode superscript equivalents
 */
const NUMBER_TO_UNICODE_MAP = {
  '0': '\u2070',
  '1': '\u00B9',
  '2': '\u00B2',
  '3': '\u00B3',
  '4': '\u2074',
  '5': '\u2075',
  '6': '\u2076',
  '7': '\u2077',
  '8': '\u2078',
  '9': '\u2079',
};

/**
 * Converts a footnote number string to its Unicode superscript equivalent
 * @param footnoteNo - The number to convert
 * @returns The Unicode superscript string
 */
export const convertFootnoteNumberToSuperscript = (footnoteNo: string) => {
  return footnoteNo
    .split('')
    .map((numPart) => NUMBER_TO_UNICODE_MAP[numPart as keyof typeof NUMBER_TO_UNICODE_MAP] || numPart)
    .join('');
};

export const extractKpiNameFromDeckline = (deckline: EnhancedDeckline) => {
  const { kpi_name: kpiName, footnotes } = deckline;
  const extractedKpiName = removeFootnoteIdsFromText(kpiName!, footnotes!);
  return extractedKpiName;
};
